import React, { useMemo } from "react";
import { EmptyStateErro } from "../../components/EmptyState";
import PainelTabela from "../../components/PainelTabela";
import { PageLoader } from "../../components/LoadingMarcenaria";
import { useDados } from "../../context/DadosContext";
import { fmtDiasEmFila } from "../../utils/calculos";
import { F } from "../../utils/gerencialFields";
import {
  buildLiberacaoStatus,
  isLiberacaoAmbientePending,
} from "../../utils/liberacaoAmbientes";
import { compareDatesAsc } from "../../utils/status";

const COLUNAS = [
  { key: "cliente", label: "Cliente", noWrap: true },
  { key: "ambiente", label: "Ambiente" },
  // `labelCurto`: rótulo da linha de metadados do card no celular/tablet.
  { key: "entregaContrato", label: "Entrega Prevista", labelCurto: "entrega", tipo: "data", width: "110px" },
  { key: "sugestaoEntrega", label: "Sugestão de Entrega", labelCurto: "sugestão", tipo: "data", width: "110px" },
  // Bloco TBL.5: gate RBAC preco:view
  { key: "valor", label: "Valor", labelCurto: "valor", tipo: "moeda", width: "110px", requerPermissao: "preco:view" },
  { key: "diasEmFila", label: "Dias em fila", labelCurto: "fila", width: "90px" },
  { key: "status", label: "Status", width: "100px" },
];

export default function LiberacaoAmbientes() {
  const { dados, erro, initialLoading } = useDados();

  // Memoizado (e antes dos early-returns — Rules of Hooks): sem isso, cada
  // re-render recriava `linhas` (filter+map+sort de 400+ itens) e a nova
  // referência invalidava toda a cadeia de memos do PainelTabela.
  const linhas = useMemo(
    () =>
      dados
        .filter(isLiberacaoAmbientePending)
        .map((row) => {
          const statusInfo = buildLiberacaoStatus(row);

          return {
            cliente: row[F.NOME_DO_CLIENTE],
            rowPlanilha: row,
            ambiente: row[F.AMBIENTE],
            entregaContrato: row[F.ENTREGA_PREVISTA],
            sugestaoEntrega: statusInfo.sugestaoEntrega,
            sugestaoOrdenacao: statusInfo.sugestaoOrdenacao,
            valor: row[F.VALOR_DO_AMBIENTE],
            // entrou na fila de liberacao na data da venda
            diasEmFila: fmtDiasEmFila(row[F.DATA_DA_VENDA]),
            status: statusInfo.status,
            statusVariant: statusInfo.statusVariant,
          };
        })
        .sort((left, right) => {
          const byContrato = compareDatesAsc(left.entregaContrato, right.entregaContrato);
          return byContrato !== 0
            ? byContrato
            : compareDatesAsc(left.sugestaoOrdenacao, right.sugestaoOrdenacao);
        }),
    [dados],
  );

  if (initialLoading) {
    return <PageLoader scope="liberacao" />;
  }

  if (erro) {
    return <EmptyStateErro erro={erro} />;
  }

  return (
    <PainelTabela
      titulo="Liberação de Ambientes"
      exportPainelId="liberacao"
      colunas={COLUNAS}
      linhas={linhas}
      densidade="compact"
      mostrarPaginacao={false}
      persistirNoBackend
    />
  );
}
